<template>
  <el-text-field
    :class="compClass"
    v-model="elValue"
    :label="label"
    :tooltip="tooltip"
    :placeholder="placeholder"
    v-mask="dateMask"
    :hide-details="hideDetails"
    :validate-key="validateKey"
    :disabled="disabled"
    :readonly="readonly"
    :required="required"
    date
    :future-dates="futureDates"
    :past-dates="pastDates"
    :today="today"
    :autofocus="autofocus"
    @blur="onBlur"
    @focus="onFocus"
  >
    <v-menu
      style="z-index: 200"
      slot="append-outer"
      :class="classP"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :disabled="disabled"
      :readonly="readonly"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" :disabled="disabled || readonly">
          mdi-calendar-month-outline
        </v-icon>
      </template>
      <v-date-picker
        :readonly="readonly"
        :disabled="disabled"
        :allowed-dates="allowedDates"
        first-day-of-week="1"
        locale="lt"
        v-model="picker"
        @input="saveDate()"
      ></v-date-picker>
    </v-menu>
    <template slot="prepend">
      <slot name="prepend"></slot>
    </template>
  </el-text-field>
</template>

<script>
export default {
  name: 'ElDatePicker',
  props: {
    classP: String,
    label: String,
    placeholder: { type: String, default: 'YYYY-MM-DD' },
    tooltip: String,
    required: Boolean,
    need: Boolean,
    value: String,
    hideDetails: [Boolean, String],
    validateKey: String,
    disabled: Boolean,
    readonly: Boolean,
    pastDates: Boolean,
    futureDates: Boolean,
    threshold: String,
    autofocus: { type: Boolean, default: false },
  },
  data() {
    return {
      menu: false,
      picker: null,
    }
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
        this.checkDateFormat(elValue)
      },
    },
    dateMask() {
      return [/[1-2]/, /\d/, /\d/, /\d/, '-', /[0-1]/, /\d/, '-', /[0-3]/, /\d/]
    },
    today() {
      let today = new Date()
      let todayStr = `${today.getFullYear()}-${this.paddingZero(
        today.getMonth() + 1
      )}-${this.paddingZero(today.getDate())}`
      if (this.threshold && this.threshold > todayStr) {
        return this.threshold
      }
      return todayStr
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonly
        ? 'required-input'
        : ''
    },
    compClass() {
      return `${this.classP} ${this.requiredClass} labelPatch`
    },
  },
  created() {
    //
  },
  methods: {
    saveDate() {
      this.menu = false
      this.elValue = this.picker
      this.onBlur(this.elValue)
    },
    checkDateFormat(elValue) {
      var dateformat = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
      if (elValue.match(dateformat)) {
        this.picker = elValue
        const field = this.$validator.fields.find({ name: this.label })
        field.reset()
        this.$validator.errors.remove(field.name, field.scope)
      } else {
        this.picker = null
      }
    },
    paddingZero(str) {
      return String(str).padStart(2, '0')
    },
    allowedDates(val) {
      if (this.pastDates) {
        return val <= this.today
      }
      if (this.futureDates) {
        return val >= this.today
      }
      return true
    },
    onBlur(e) {
      this.$emit('blur', e)
    },
    onFocus(e) {
      this.$emit('focus', e)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
